// extracted by mini-css-extract-plugin
export default {"home":"index_home__xksxi","content":"index_content__UhLVI","top":"index_top__RnnWY","table":"index_table__KP+Or"};